/* istanbul ignore file */
export const goToPage = (page: string) => (window.location.href = page);
